import { useState } from "react";
import { ITradeOrder } from "@/services/trade/order";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import styles from "./Controls.module.scss";

interface ITooltipedButtonProps {
    isActive: boolean;
    setShowIsActive: (isOpen: boolean) => void;
    title?: string;
    imgUrl: string;
    imgUrlHover: string;
    orders?: ITradeOrder[] | any[];
    isNoWrapText?: boolean;
    id?: string;
    noDisplayingAmount?: boolean;
    isLockedAmount?: boolean;
}

export const TooltipedButton: React.FC<ITooltipedButtonProps> = ({
    isActive,
    setShowIsActive,
    title,
    imgUrl,
    imgUrlHover,
    orders = null,
    isNoWrapText = true,
    noDisplayingAmount = false,
    isLockedAmount = false,
    id,
}) => {
    const { t } = useTranslation("common");
    const [tooltipId, setTooltipId] = useState(null);

    const displayAmount = orders?.length > 99 ? "99+" : `${orders?.length || "0"}`;

    return (
        <div
            id={title}
            className={clsx(styles.item, {
                [styles.listItem]: orders,
                [styles.active]: isActive,
            })}
            onMouseLeave={() => setTooltipId(null)}
            onMouseOver={() => title && setTooltipId(title)}
            onFocus={() => void 0}
            onClick={() => setShowIsActive(!isActive)}>
            <div
                style={{
                    bottom: orders ? 66 : 75,
                }}
                className={clsx(styles.tooltip, {
                    [styles.visible]: tooltipId === title,
                    [styles.noWrapText]: !isNoWrapText,
                })}>
                <div
                    className={clsx(styles.text, {
                        [styles.noWrapText]: !isNoWrapText,
                    })}>
                    {t(title)}
                    <div className={styles.triangle} />
                </div>
            </div>
            {orders && !isLockedAmount && (
                <div className={styles.listCount}>
                    <span>{displayAmount}</span>
                </div>
            )}

            {!isLockedAmount && noDisplayingAmount && (
                <div className={clsx(styles.listCount, styles.reload)}>
                    <span></span>
                </div>
            )}

            {isLockedAmount && (
                <div className={clsx(styles.listCount, styles.lock)}>
                    <span></span>
                </div>
            )}
            <div>
                <img className={styles.img} src={imgUrl} alt="intro" />
                <img id={id || null} className={styles.imgHover} src={imgUrlHover} alt="intro" />
            </div>
        </div>
    );
};
